export default "/_next/static/images/7e24a020da12320b9278b5b0108f53d0.jpg";